import { ImageLoaderConfig } from '@angular/common';

export function youtubeImageLoader(config: ImageLoaderConfig): string {
  let videoId = '';

  if (
    config.src.includes('img.youtube.com') ||
    config.src.includes('i.ytimg.com')
  ) {
    const match = config.src.match(/\/vi\/([^/]+)\//);
    if (match && match[1]) {
      videoId = match[1];
    }
  } else {
    const youtubeRegex =
      /https?:\/\/(?:img\.youtube\.com|i\.ytimg\.com)\/vi\/([^/]+)\/.*\.jpg/;
    const match = config.src.match(youtubeRegex);
    if (match && match[1]) {
      videoId = match[1];
    }
  }

  if (videoId) {
    let filename = 'maxresdefault.webp';
    if (config.width) {
      if (config.width <= 320) {
        filename = 'mqdefault.webp';
      } else if (config.width <= 480) {
        filename = 'hqdefault.webp';
      } else if (config.width <= 640) {
        filename = 'sddefault.webp';
      }
    }
    return `https://i.ytimg.com/vi_webp/${videoId}/${filename}`;
  }

  return config.src;
}
